import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileValidators } from 'ngx-file-drag-drop';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-projects-providers-reload',
  templateUrl: './projects-providers-reload.component.html',
  styleUrls: ['./projects-providers-reload.component.scss']
})
export class ProjectsProvidersReloadComponent implements OnInit {

  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([],[FileValidators.uniqueFileNames, FileValidators.maxFileCount(1)]);
  providers : any = [];
  folder : any;
  id_provider_survey : any;
  id_provider : any;
  nombre : any = "";
  hostName : any = "";
  id_campana_proyecto : any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,    
    private fb : FormBuilder,    
    private projectService : ProjectsService,
    private main : MainService,
    private dialogRef: MatDialogRef<ProjectsProvidersReloadComponent>,
  ) { 

    this.folder = this.data.folder;
    this.id_provider_survey = this.data.id_provider_survey;
    this.nombre = this.data.nombre;
    this.id_provider = this.data.id_provider;
    this.id_campana_proyecto = this.data.id_campana_proyecto;
    
    this.hostName = window.location.protocol + '//' + window.location.host + "/providers/";
  }

  ngOnInit(): void {
    this.getProviders();
    this.loadForm();
    this.preloadFormData();
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null, {validators:[Validators.required]}],
      provider_msg : [""]
    });
  }

  preloadFormData(){
    this.bodyForm.append('folder', this.folder as string);
    this.bodyForm.append('id_provider_survey', this.id_provider_survey);
  }


  onValueChange(files : any)
  { 
    if(files.length >= 2)
    {      
      files.splice(1, 1);
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'Sólo puede adjuntarse un documento'
      });
    }

    for (const item of files) {
      if(!(item.name.endsWith('.pdf')))
      {
        const index = files.indexOf(item);
  
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          html: 'Solo se permiten documentos en formato .PDF'
        });
    
        if (index >= 0) {
          files.splice(index, 1);
        }
      }
    }
  }

  saveFile() {
      Swal.fire({
        title: '¿Estás seguro que deseas guardar el registro?',
        text: '¡Se enviará notificación a Proveedor!',
        icon: 'warning',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`
      }).then((result) => {      
        if (result.isConfirmed) {
            this.uploadFile();
        }
      });
  }

  getProviders(){
    this.projectService.getProviders().subscribe(
      (result:any) => {
       this.main.HideLoading();
       this.providers = result.data;
      },
      (err:any) => {
        this.main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros de proveedores.'
          });
        
      }
    );
  }


  uploadFile(){ 
    if(this.form.value.blob != null && this.form.value.blob?.length!=0 ){
      this.bodyForm.append("blob", this.form.value.blob[0] as File);
      this.bodyForm.append("provider_msg", this.form.controls.provider_msg.value);
      this.bodyForm.append("id_provider", this.id_provider);
      this.bodyForm.append("id_campana_proyecto", this.id_campana_proyecto);
      this.bodyForm.append("host", this.hostName);
      Swal.fire({
        icon: 'info',
        title: 'Subiendo archivo...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.projectService.reuploadCampaignProviderFile(this.bodyForm).subscribe(
        (result:any)=>{
          if(result.message == 'Success'){
            Swal.fire({
              icon: 'success',
              title: 'Archivo subido',
              text: 'Archivo subido exitosamente'          
            }).then(() => {            
              this.dialogRef.close({ reload: true });
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
            });
          }
        },
        (err:any)=>{
          this.main.HideLoading();
          if(err.error.message == "Invalid file") {
            Swal.fire({
              icon: 'warning',
              title: 'Error',
              html: 'Solo se permiten documentos en formato .PDF'
            });
      
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
            });
          }
        }
      )
      
  }else{
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'El documento no ha sido adjuntado'
      });
    }
  }
}
